// Get backend URL based on environment
const getBackendUrl = () => {
  if (import.meta.env.MODE === 'development') {
    return 'http://localhost:5001';
  }
  return ''; // Use relative path in production (proxied by nginx)
};

const API_BASE = `${getBackendUrl()}/api/v1`;

// Get auth token
const getAuthHeaders = () => {
  const token = localStorage.getItem('tkn');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
};

// Get all patients
export const getPatients = async (filters = {}) => {
  try {
    const params = new URLSearchParams(filters);
    const response = await fetch(`${API_BASE}/patients?${params}`, {
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch patients');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching patients:', error);
    throw error;
  }
};

// Get single patient
export const getPatientById = async (id) => {
  try {
    const response = await fetch(`${API_BASE}/patients/${id}`, {
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch patient');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching patient:', error);
    throw error;
  }
};

// Create patient
export const createPatient = async (patientData) => {
  try {
    const response = await fetch(`${API_BASE}/patients`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(patientData),
    });

    if (!response.ok) {
      throw new Error('Failed to create patient');
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating patient:', error);
    throw error;
  }
};

// Update patient
export const updatePatient = async (id, patientData) => {
  try {
    const response = await fetch(`${API_BASE}/patients/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(patientData),
    });

    if (!response.ok) {
      throw new Error('Failed to update patient');
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating patient:', error);
    throw error;
  }
};

// Delete patient
export const deletePatient = async (id) => {
  try {
    const response = await fetch(`${API_BASE}/patients/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to delete patient');
    }

    return await response.json();
  } catch (error) {
    console.error('Error deleting patient:', error);
    throw error;
  }
};

// Search patients
export const searchPatients = async (query) => {
  try {
    const response = await fetch(`${API_BASE}/patients/search?q=${encodeURIComponent(query)}`, {
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to search patients');
    }

    return await response.json();
  } catch (error) {
    console.error('Error searching patients:', error);
    throw error;
  }
};

// Get patient statistics
export const getPatientStats = async () => {
  try {
    const response = await fetch(`${API_BASE}/patients/stats`, {
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch patient statistics');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching patient stats:', error);
    throw error;
  }
};
